// extracted by mini-css-extract-plugin
module.exports = {"main_box":"styles_main_box__SEXx3","active":"styles_active__Zpa3X","btn_link":"styles_btn_link__PF5-r","text":"styles_text__3qZec","active_text":"styles_active_text__2M4Yx"};